import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 4v16M9 4v16M14 5l5 14" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "3",
  y: "4",
  width: "2",
  height: "16",
  rx: ".5",
  fill: "currentColor",
  stroke: "none"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("svg", {
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    xmlns: "http://www.w3.org/2000/svg",
    style: _normalizeStyle($props.color ? { color: $props.color } : undefined)
  }, _hoisted_4, 12, _hoisted_1))
}

import { defineComponent as _defineComponent } from 'vue'

const __script = /*#__PURE__*/_defineComponent({
  __name: 'library.svg',
  props: {
  size: { type: Number, default: 24 },
  color: { type: String, default: undefined },
},
  setup(__props, { expose }) {
  expose();



const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})

__script.render = render
export default __script